/*
 * Crifalu: Set-Angebot in der Kaufbox (Block „set_offer“ in main-product.liquid).
 *
 * Zwei Optionskarten (nur Hauptprodukt / Set mit Zusatzprodukt). Die Auswahl wird auf eine
 * versteckte Checkbox name="bundles" gespiegelt, die das Theme-Formular (ProductForm in theme.js)
 * beim Hinzufügen zum Warenkorb als zweiten Artikel mitnimmt. Der Kaufbutton-Preis
 * (product-buy-price) hört auf „bundle:change“ und zeigt so den Set-Preis an.
 * Der eigentliche Set-Vorteil wird durch einen automatischen Rabatt im Shopify-Admin abgezogen.
 */
if (!customElements.get('crifalu-set-offer')) {
  class CrifaluSetOffer extends HTMLElement {
    constructor() {
      super();
      this.onChange = this.onChange.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);
      this.onCartUpdate = this.onCartUpdate.bind(this);
    }

    get productForm() {
      const id = this.getAttribute('form');
      return id ? document.forms[id] : null;
    }

    get bundleInput() {
      return this.querySelector('input[name="bundles"]');
    }

    get radios() {
      return Array.from(this.querySelectorAll('input[type="radio"]'));
    }

    get setSelected() {
      const checked = this.radios.find((radio) => radio.checked);
      return !!checked && checked.value === 'set';
    }

    get saving() {
      return parseInt(this.getAttribute('data-saving')) || 0;
    }

    get addonPrice() {
      return parseInt(this.bundleInput?.getAttribute('data-price')) || 0;
    }

    get basePrice() {
      return parseInt(this.getAttribute('data-base-price')) || 0;
    }

    connectedCallback() {
      this.addEventListener('change', this.onChange);
      (this.productForm ?? document).addEventListener('variant:change', this.onVariantChange);
      if (window.theme?.pubsub) {
        this.cartUpdateUnsubscriber = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate);
      }
      // Auswahl und versteckte Checkbox angleichen (z. B. nach Zurück-Navigation mit Formular-Cache)
      this.syncBundleInput();
      if (this.bundleInput?.checked) this.publish();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      (this.productForm ?? document).removeEventListener('variant:change', this.onVariantChange);
      if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
    }

    onChange(event) {
      if (event.target.type !== 'radio') return;
      this.syncBundleInput();
      this.publish();
    }

    syncBundleInput() {
      const input = this.bundleInput;
      if (!input) return;
      input.checked = this.setSelected && !input.disabled;
      this.classList.toggle('is-set-selected', input.checked);
    }

    publish() {
      const input = this.bundleInput;
      const items = input && input.checked
        ? [{ id: input.value, quantity: 1, price: String(Math.max(this.addonPrice - this.saving, 0)) }]
        : [];
      (this.productForm ?? document).dispatchEvent(new CustomEvent('bundle:change', { detail: { items } }));
    }

    onVariantChange(event) {
      const variant = event.detail?.variant;
      if (variant && typeof variant.price === 'number') {
        this.setAttribute('data-base-price', variant.price);
        this.updatePrices();
      }
      // Der Kaufbutton-Preis wurde beim Variantenwechsel neu gerendert und kennt das Set nicht mehr.
      if (this.bundleInput?.checked) this.publish();
    }

    onCartUpdate(event) {
      // Nach dem Hinzufügen zum Warenkorb zurück auf „nur Hauptprodukt“ (wie product-bundle-details im Theme)
      if (event.source !== 'product-form' || !this.bundleInput?.checked) return;
      const solo = this.radios.find((radio) => radio.value === 'solo');
      if (solo) solo.checked = true;
      this.syncBundleInput();
      this.publish();
    }

    updatePrices() {
      const format = theme.settings.currencyCodeEnabled ? theme.settings.moneyWithCurrencyFormat : theme.settings.moneyFormat;
      const regular = this.basePrice + this.addonPrice;
      const total = Math.max(regular - this.saving, 0);
      this.querySelectorAll('[data-set-solo-price]').forEach((el) => { el.innerHTML = theme.Currency.formatMoney(this.basePrice, format); });
      this.querySelectorAll('[data-set-total]').forEach((el) => { el.innerHTML = theme.Currency.formatMoney(total, format); });
      this.querySelectorAll('[data-set-regular]').forEach((el) => { el.innerHTML = theme.Currency.formatMoney(regular, format); });
    }
  }

  customElements.define('crifalu-set-offer', CrifaluSetOffer);
}
